import styled from "styled-components";

export const Wrapper = styled.div`
  height: 1px;
  width: 100%;
  background-image: linear-gradient(
    to right,
    rgba(0, 0, 0, 0),
    ${(props) => props.color} 40%,
    ${(props) => props.color} 60%,
    rgba(0, 0, 0, 0)
  );
`;
